import React from 'react';
import ProjectList from '../../../../pages/Projects/sections/Project/ProjectList';

interface WorkUnitsTableViewProps {
  data: any[];
  handleProjectClick: (data?: any, toggleTable?: boolean) => void;
  loading: boolean;
  loadingMore: boolean;
  onLoadMore: () => void;
  hasMore: boolean;
  visibleColumns: Record<string, boolean>;
  setVisibleColumns?: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  isLocalFilterApplied: boolean;
  scrollRef: React.RefObject<HTMLDivElement>;
}

const WorkUnitsTableView: React.FC<WorkUnitsTableViewProps> = ({
  data,
  handleProjectClick,
  loading,
  loadingMore,
  onLoadMore,
  hasMore,
  visibleColumns,
  setVisibleColumns,
  isLocalFilterApplied,
  scrollRef
}) => {
  return (
    <ProjectList
      data={data}
      handleProjectClick={handleProjectClick}
      loading={loading}
      loadingMore={loadingMore}
      onLoadMore={onLoadMore}
      hasMore={hasMore}
      visibleColumns={visibleColumns}
      setVisibleColumns={setVisibleColumns}
      isLocalFilterApplied={isLocalFilterApplied}
      scrollRef={scrollRef}
      externalScroll={true}
    />
  );
};

export default WorkUnitsTableView;
